<template>
  <div
    class="stage"
    :class="[block, item.id === 'registration' ? 'stage-registration' : '', isVideoresume ? 'stage-videoresume' : '']"
  >
    <div class="landing_title">
      {{ name }}

      <span v-if="item.id === 'resume' && !isResumeMandatory && isVideoresume" class="landing_title--note">
        {{ $tr('vacancy.openRegistrationVideoresume.stages.cvOptional') }}
      </span>
    </div>

    <div class="landing_text" v-html="description"></div>

    <template v-if="item.id !== 'resume' || item.finished">
      <div v-if="item.minutes_length && item.finished !== true" class="landing_time">
        {{ $tr('interview.landing.modules.minutes_length') }}&nbsp;
        <span>{{ durationHumanReadable }}</span>
      </div>

      <div class="stage__buttons">
        <vbutton
          v-if="!isVideoresume && item.finished === false && item.can_pass && !disableRecord && item.id !== 'chatbot'"
          class="interview_button"
          :label="item.button_text"
          :disabled="loading || isDisabled"
          :loading="loading"
          @click="$emit('goto', item.id)"
        />

        <vbutton
          v-if="!isVideoresume && item.finished === false && item.can_pass && !disableRecord && item.id === 'chatbot'"
          class="interview_button"
          :label="item.button_text"
          :disabled="loading || isDisabled"
          :loading="loading"
          @click="openLink(interview.chatbot_link)"
        />

        <span
          v-if="
            !isVideoresume &&
            item.finished === false &&
            item.can_pass &&
            !disableRecord &&
            item.id === 'survey' &&
            interview.chatbot_link
          "
        >
          {{ $tr('vacancy.preferences.footerInfo.first.content.or') }}
        </span>

        <a
          v-if="
            !isVideoresume &&
            item.finished === false &&
            item.can_pass &&
            !disableRecord &&
            item.id === 'survey' &&
            interview.chatbot_link
          "
          :href="interview.chatbot_link"
          :disabled="loading || isDisabled"
          target="_blank"
          class="stage__telegram-button"
        >
          <img src="/static/images/logo_telegram.svg" alt="" />
          <span>Telegram</span>
        </a>
      </div>

      <div v-if="item.finished === false && disableRecord" class="closed">
        {{ disable_text }}
      </div>
    </template>

    <template v-if="item.id === 'resume' && !isResumeFinished">
      <resume-upload
        class="stage-resume"
        :item="item"
        :is-videoresume="isVideoresume"
        :is-finished="(item.resumeName !== null || item.resumeUrl !== null) && isResumeFinished"
        @upload="uploadResume"
        @reset="$emit('resetFile')"
        @uploadResumeUrl="uploadResumeUrl"
        @setResumeName="setResumeName"
      />
    </template>
  </div>
</template>

<script>
import resumeUpload from '../resumeUpload.vue';

export default {
  name: 'StageDefault',

  components: {
    resumeUpload
  },

  props: [
    'item',
    'companyInfo',
    'activeModules',
    'isDisabled',
    'loading',
    'interview',
    'isVideoresume',
    'isResumeMandatory',
    'isResumeFinished',
    'hasValidResume'
  ],

  computed: {
    block() {
      if (this.item.id !== 'resume') {
        return this.item.finished === true ? true : this.item.id;
      }
      return this.isResumeFinished ? true : this.item.id;
    },

    hasVideo() {
      if (!this.activeModules || !this.activeModules.length) {
        return false;
      }

      let has_video = false;

      this.activeModules.forEach(activeModule => {
        if (activeModule.id !== 'test') {
          return;
        }

        if (activeModule.child_modules && activeModule.child_modules.length) {
          activeModule.child_modules.forEach(childModule => {
            if (childModule.id === 'anticheating') {
              has_video = true;
            }
          });
        }
      });
      return has_video;
    },

    description() {
      if (!this.item || !this.item.id) {
        return '';
      }

      if (this.item.id !== 'test' || !this.hasVideo) {
        return this.item.description;
      } else {
        return `${this.item.description} <br>${this.$tr('interview.test.passing.agreeVideo')}`;
      }
    },

    disableRecord() {
      return (
        this.companyInfo.is_disable_record_videointerview ||
        (this.interview && this.interview.vacancy && !this.interview.vacancy.is_active)
      );
    },

    disable_text() {
      if (this.block === 'test') {
        return this.$tr('interview.landing.modules.disableTest');
      } else {
        return this.$tr('interview.landing.modules.disableRecord');
      }
    },

    name() {
      if (this.isVideoresume) {
        if (this.item.id === 'video' || this.item.id === 'videointerview') {
          return this.$tr('vacancy.openRegistrationVideoresume.stages.video');
        } else if (this.item.id === 'survey') {
          return this.$tr('vacancy.openRegistrationVideoresume.stages.survey');
        } else if (this.item.id === 'resume') {
          return this.$tr('vacancy.openRegistrationVideoresume.stages.resume');
        }
      }

      // if (this.item.id === 'video') {
      //   return this.item.title;
      // } else {
      //   return this.item.name;
      // }

      return this.item.name;
    },

    durationHumanReadable() {
      const minutes = this.item.minutes_length || 0;
      return this.$moment.duration(minutes, 'minutes').format('HH:mm:ss');
    }
  },

  methods: {
    uploadResume(file) {
      this.$emit('uploadResume', file);
    },

    uploadResumeUrl(v) {
      this.$emit('uploadResumeUrl', v);
    },

    setResumeName(v) {
      this.$emit('setResumeName', v);
    },

    setError(v) {
      this.$emit('setError', v);
    },

    openLink(chatbotLink) {
      window.open(chatbotLink, '_blank');
    }
  }
};
</script>

<style lang="scss" scoped>
.stage {
  border-top: 1px solid #d2d6e0;
  padding-top: 30px;
  padding-bottom: 30px;

  .landing_title {
    color: #233346;
    font-style: normal;
    line-height: normal;
    font-size: 18px;
    height: 45px;
    line-height: 26px;
    font-weight: 500;
    overflow: hidden;
    text-overflow: ellipsis;
    padding-left: 32px;
    background: url('/static/icons/landing_ok_2.svg') left top no-repeat;
    background-size: 25px 28px;
  }
  &:first-child {
    border-top: 0;
  }
  .stage-registration {
    padding-top: 15px;
    padding-bottom: 5px;

    .landing_title {
      background-position: left 11px;
      padding-top: 15px;
      height: 60px;
      box-sizing: border-box;
    }
  }
  &.survey {
    .landing_title {
      background: url('/static/icons/landing_survey_2.svg') left top no-repeat;
      background-size: 25px 28px;
    }
  }
  &.integration {
    .landing_title {
      background: url('/static/icons/landing_integration.svg') left top no-repeat;
      background-size: 25px 28px;
    }
  }
  &.test,
  &.talentq {
    .landing_title {
      background-image: url(/static/icons/landing_test_2.svg);
      background-position: left top;
      background-repeat: no-repeat;
      background-size: 25px 28px;
    }
  }
  &.video {
    .landing_title {
      background-image: url(/static/icons/landing_video_2.svg);
      background-repeat: no-repeat;
      background-position: left top;
      background-size: 25px 28px;
    }
  }
  &.resume {
    .landing_title {
      background: url('/static/icons/landing_cv.svg') left top no-repeat;
      background-size: 25px 28px;
    }
  }
  .landing_text {
    font-style: normal;
    font-weight: normal;
    line-height: 22px;
    font-size: 15px;
    margin-left: 32px;
    margin-top: -2px;
    color: #233346;
    white-space: pre-wrap;
  }
  .landing_time {
    font-style: normal;
    font-weight: normal;
    line-height: 22px;
    font-size: 15px;
    letter-spacing: 0.005em;
    margin-left: 32px;
    margin-top: 20px;
  }

  .closed {
    padding: 10px;
    margin-top: 15px;
    text-align: center;
    font-size: 15px;
    line-height: 22px;
    width: 100%;
    background: rgba(254, 64, 53, 0.15);
    color: #f65046;
  }

  &__buttons {
    display: flex;
    align-items: center;
    margin-top: 15px;
  }

  .interview_button {
    margin-left: 32px;
    margin-right: 15px;
    max-width: 375px;
    box-sizing: border-box;
  }

  &__telegram-button {
    height: 40px;
    display: inline-block;
    padding: 0 15px;
    color: #fff;
    border: 1px solid #28a7e8;
    border-radius: 3px;
    display: flex;
    margin-left: 15px;
    align-items: center;
    transition: background 0.3s;

    img {
      height: 24px;
      width: 24px;
      margin-right: 10px;
    }

    span {
      color: #28a7e8;
    }

    &:hover,
    &:active,
    &:focus {
      background: lighten(#28a7e8, 40%);
      transition: background 0.3s;

      span {
        color: #28a7e8;
      }
    }

    &.disabled {
      pointer-events: none;
      opacity: 0.65;
    }
  }
}

.stage-resume {
  margin-left: 2rem;
  margin-top: 1rem;
}

.stage.stage-videoresume {
  &.stage {
    padding-top: 20px;
    padding-bottom: 20px;
    &:first-child {
      padding-top: 0;
    }
    .landing_time {
      font-style: normal;
      font-weight: normal;
      line-height: 22px;
      font-size: 15px;
      letter-spacing: 0.005em;
      margin-left: 32px;
      margin-top: 20px;
    }
    .interview_button {
      // margin-top: 24px;
      // margin-left: 30px;
      max-width: 375px;
      box-sizing: border-box;
    }
    .closed {
      padding: 10px;
      margin-top: 15px;
      text-align: center;
      font-size: 15px;
      line-height: 22px;
      width: 100%;
      background: rgba(254, 64, 53, 0.15);
      color: #f65046;
    }

    &__buttons {
      display: flex;
      margin-top: 24px;
      align-items: center;
      margin-left: 30px;

      > span {
        margin-left: 15px;
      }
    }
  }
  .landing_modules .interview_button {
    margin-top: 0;
  }
  .landing_title {
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    line-height: 28px;
    color: #555555;
    overflow: hidden;
    text-overflow: ellipsis;
    padding-left: 32px;
    height: 28px;
  }

  .stage-resume {
    margin-top: 12px;
  }

  &.survey {
    .landing_title {
      background: url('/static/images/elements/b2c-interview-survey.svg') left top no-repeat;
      background-size: 25px 28px;
    }
  }
  &.video {
    .landing_title {
      background-image: url(/static/images/elements/b2c-interview-video.svg);
      background-repeat: no-repeat;
      background-position: left 6px;
    }
  }
  &.resume {
    .landing_title {
      background: url('/static/images/elements/b2c-interview-cv.svg') left top no-repeat;
      background-size: 25px 28px;
    }
  }

  .landing_title--note {
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 24px;
    color: #c4b9d3;
  }

  .landing_text,
  .landing_time {
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 24px;
    color: #555555;
    margin: 0 0 0 32px;
    white-space: pre-wrap;
    height: auto;
  }

  .landing_time {
    display: flex;
    align-items: center;
    margin-top: 14px;
    white-space: initial;
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 24px;
    color: #8d8d8d;
  }

  .landing_text {
    margin-top: 12px;
  }
}
</style>
